import ValidatePin from "./ValidatePin";
export default ValidatePin;
